import { json } from 'react-router-dom'
import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter'

export const loadAccounts = async () => {
  let accounts = await Axois.get('accounts').catch((err) => {
    throw new Error(
      'Could not fetch data!\nPlease check your network connectivity!'
    )
  })
  // if (accounts.status === 'failed') throw json({ message: accounts.message, status: accounts.status })
  const responseData = await accounts.data

  return responseData
}

export const loadOneAccount = async (action) => {
  try {
    switch(action) {
      case 'new':
        let response = await Axois.get('setups/chart-of-account');
        let resData = await response.data;
        return {...resData, account: {}}
      
      default:  
        let accounts = await Axois.get('accounts/find/'+action).catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
        const responseData = await accounts.data;
        return responseData;
    }
  }catch (err) {
    console.log(err);
  }
}


const useAccountAPI = () => {

  const create = async(data, success) => {
    try {
      const response = await Axois.post('accounts/create', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('account_created', responseData.code);
    }catch (err) {
      console.log(err);
    }
  }

  const update = async(code, data, success) => {
    try {
      const response = await Axois.put('accounts/'+code, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('account_updated', responseData.code);
    }catch (err) {
      console.log(err);
    }
  }

  return { create, update };
}


export default useAccountAPI;